module.exports = __webpack_public_path__ + "img/solar.ee3b66d9.png";